import type { ReactNode } from "react";
import { Button } from "@volca/ui/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";

interface IconButtonWithTooltipProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: ReactNode;
}

export const IconButtonWithTooltip = ({
  label,
  onClick,
  disabled,
  className,
  children,
}: IconButtonWithTooltipProps) => (
  <Tooltip>
    <TooltipTrigger render={<span />}>
      <Button
        variant="ghost"
        size="icon"
        aria-label={label}
        onClick={onClick}
        disabled={disabled}
        className={cn(className)}
      >
        {children}
      </Button>
    </TooltipTrigger>
    <TooltipContent>{label}</TooltipContent>
  </Tooltip>
);
